<template>
  <a-form-item
    :label="label || 'Plantilla'"
    :name="name || 'template'"
    :rules="[{ required: required, message: 'Por favor seleccionar una plantilla' }]"
  >
    <a-select
      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      :value="value"
      :disabled="!queue"
      placeholder="Seleccionar plantilla"
      @update:value="handleChange"
    >
      <a-select-option v-for="item in templates" :key="item.id">
        {{ item.name }}
      </a-select-option>
    </a-select>
  </a-form-item>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { debounce } from "lodash";

import { WppTemplate } from "@/@types/global";
import { fetchTemplates } from "@/app/workspace/services";

const props = defineProps<{
  label?: string;
  name?: string;
  required?: boolean;
  value?: number | null;
  queue?: number | null;
}>();

const emit = defineEmits<{
  (e: "update:value", newValue?: number): void;
  (e: "selectTemplate", template?: WppTemplate): void;
}>();

const templates = ref<WppTemplate[]>([]);

const emitSelectedTemplate = (newValue: number | null | undefined) => {
  if (!newValue) return;
  const currentTemplate = templates.value.find((template) => template.id === newValue);
  emit("selectTemplate", currentTemplate);
};

const handleChange = (newValue: number) => {
  emit("update:value", newValue);

  emitSelectedTemplate(newValue);
};

watch(templates, () => {
  emitSelectedTemplate(props.value);
});

watch(
  () => props.queue,
  debounce(async (newQueue, prevQueue) => {
    if (prevQueue) {
      emit("selectTemplate", undefined);
      emit("update:value", undefined);
    }

    if (newQueue !== undefined) {
      templates.value = await fetchTemplates(newQueue, "", true);
    }
  }, 200),
  { immediate: true }
);
</script>

<style scoped lang="sass"></style>
